module.exports = __webpack_public_path__ + "img/listview-activatejob.488ec265.svg";